import { useRef } from 'react'

type InstanceRef<T> = { current: T }

const noValue = Symbol('lazyRef.noValue')

export function useInstanceRef<T>(getInitialValue: () => T): InstanceRef<T> {
  const lazyRef = useRef<T | symbol>(noValue)

  if (lazyRef.current === noValue) {
    lazyRef.current = getInitialValue()
  }

  return lazyRef as InstanceRef<T>
}
